import LoginPage from "units/auth/LoginPage";
import "./i18n/index";
import RegisterPage from "units/auth/RegisterPage";
import useModeSetting from "units/dashboard/hooks/useModeSetting";
import ProtectedRoute from "units/auth/components/ProtectedRoute";
import { ThemeProvider } from "units/dashboard/context/ThemeProvider";
import { LanguageProvider } from "units/dashboard/context/LanguageProvider";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import ToastProvider from "./toast/ToastProvider";
import RegisterPageStepTwo from "units/auth/RegisterPageStepTwo";
import CreatingKnowledgeBase from "units/user/CreatingKnowledgeBase";
import AdminPublishList from "units/admin/AdminPublishList";
import Test from "units/Test";
import LittelInfo from "units/user/LittelInfo";
import CreatChankfile from "units/user/CreatChankfile";
import DashboardLayout from "units/dashboard/layouts/DashboardLayout";
import AdminDashboard from "units/admin/AdminDashboard";
import UserDashboard from "units/user/userDashboard/UserDashboard";

import { SidebarProvider } from "units/dashboard/context/SidebarProvider";

import ClientRegister from "units/client/ClientRegister";
import Bot from "units/bot/Bot";
import ClientVerifyRegisterCode from "units/client/ClientVerifyRegisterCode";
import ClientDashboard from "units/client/component/ClientDashboard";

import ChatBotContainer from "units/chatbot/components/ChatBotContainer";
import ClientChatBotContainer from "units/client/ClientChatBot/ClientChatBotContainer";

import ChatConversion from "units/chatbot/components/ChatConversion";
import ClientChatConversion from "units/client/ClientChatBot/ClientChatConversion";

import NotFoundPage from "units/NotFoundPage";
import ChangeUserPassword from "units/user/ChangeUserPassword";
import PlanSelector from "units/user/subscription/PlanSelector";

import AdminChangePassword from "units/admin/AdminChangePassword";

import PlanCart from "units/user/subscription/plans/PlanCart";
import PaymentOptions from "units/payment/PaymentOptions";
import PaymentGatewaySelector from "units/payment/PaymentGatewaySelector";
import UserWallet from "units/user/subscription/UserWallet";
import PaymentFeedback from "./units/payment/PaymentFeedback";

import CreatePlan from "./units/admin/plans/CreatePlan";
import EditPlan from "./units/admin/plans/EditPlan";
import MyPlans from "./units/admin/plans/MyPlans";
import OfferCodes from "./units/admin/offerCodes/OfferCodes";
import UserPlansList from "./units/admin/plans/userPlansList/UserPlansList";
import TransactionsList from "./units/admin/transactions/TransactionsList";

import PlansList from "./units/user/subscription/userPlansList/PlansList";
import Setting from "./units/admin/setting/Setting";
import UserTransactionList from "./units/user/userTransactionList/UserTransactionList";

import NewUserDahboard from "./units/user/userDashboard/NewUserDahboard";

import SignIn from "./units/auth/components/SignIn";
import Auth from "./units/auth/Auth";
import AuthForm from "./units/user/authForm/AuthForm";

import { Blogs } from "./blogs";
import Landing from "units/landing/Landing";

import DailyMsgCountChart from "units/user/userDashboard/components/charts/DailyMsgCountChart";
import HourlyMsgCountChart from "units/user/userDashboard/components/charts/HourlyMsgCountChart";
import TopBotUsersChart from "units/user/userDashboard/components/charts/TopBotUsersChart";

import MyTools from "units/user/tools/myTools/MyTools";
import AddNewTool from "units/user/tools/addNewTool/AddNewTool";

import BigChartPage from "units/user/userDashboard/components/charts/BigChartPage";

// import PrivacyPolicy from "./units/components/PrivacyPolicy";
// import TermsAndConditions from "./units/components/TermsAndConditions";

import PersonalPlanRequest from "./units/admin/personalPlanRequest/PersonalPlanRequest";

import ClientEnterPassword from "./units/client/ClinetEnterPassword";

import FloatingStepper from "units/components/FloatingStepper/FloatingStepper";

import ClientWallet from "./units/client/ClientChatBot/ClientWallet";
import ClientPaymentGatewayMethod from "./units/client/ClientChatBot/ClientPaymentGatewayMethod";

import Settlements from "./units/user/settlements/settlements"

import SettlementRequestsList from "./units/admin/SettlementRequestsList"

import WobList from "./units/user/WobList"

import Qif from "./units/user/Qif"

import CreateFunnelCriteria from "./units/admin/funnelSell/CreateFunnelCriteria"

import CreateReadyFunnel from "./units/admin/funnelSell/CreateReadyFunnel"

import ReadyFunnels from "./units/admin/funnelSell/ReadyFunnels"

import ChangeUserNumber from "./units/user/EditUserNumber"

import WelcomeMessage from "./units/user/WelcomeMessage"

/* =========================
   Bot Chat
========================= */

const BotChat = () => {
  const { botType } = useParams();

  const botTitles = {
    supportBot: "گفتگوهای پشتیبانی",
    adminSupportBot: "گفتگوهای پشتیبانی",
    RayaBot: "گفتگو های رایابات",
  };

  return (
    <ChatBotContainer
      headerTitle={"چت بات"}
    >
      <Outlet />
    </ChatBotContainer>
  );
};


/* =========================
   Client Bot Chat
========================= */

const ClientBotChatRoute = () => {
  return (
    <ClientChatBotContainer>
      <Outlet />
    </ClientChatBotContainer>
  );
};


/* =========================
   Routes
========================= */

const AppRoutes = () => {
  const location = useLocation();

  const isRoadmapVisible = location.pathname.startsWith("/user");

  return (
    <>
      {/* FloatingStepper فقط در صفحات User */}
      {isRoadmapVisible && <FloatingStepper />}

      <Routes>

        {/* =========================
            Auth
        ========================= */}

        <Route path="/signIn" element={<SignIn />} />

        <Route path="/login" element={<Auth />} />

        <Route path="/forgotPassword" element={<Auth />} />

        <Route path="/register" element={<Auth />} />


        {/* =========================
            User Routes
        ========================= */}

        <Route
          path="/user/dashboard"
          element={
            <ProtectedRoute
              element={<UserDashboard />}
            />
          }
        />

        <Route
          path="/user/authorization"
          element={<AuthForm />}
        />

        <Route
          path="/user/edit-info"
          element={<AuthForm />}
        />

        <Route
          path="/user/tools"
          element={<MyTools />}
        />

        <Route
          path="/user/add-new-tool"
          element={<AddNewTool />}
        />

        <Route
          path="/user/message-per-day"
          element={<BigChartPage />}
        />

        <Route
          path="/user/message-per-hour"
          element={<BigChartPage />}
        />

        <Route
          path="/user/top-users"
          element={<BigChartPage />}
        />

        <Route
          path="/user/home"
          element={<NewUserDahboard />}
        />

        <Route
          path="/user/knowledgeBase"
          element={<CreatingKnowledgeBase />}
        />

        <Route
          path="/user/changePassword"
          element={<ChangeUserPassword />}
        />

        <Route
          path="/user/plan"
          element={<PlanSelector />}
        />

        <Route
          path="/user/plan-list"
          element={<PlansList />}
        />

        <Route
          path="/user/transaction-list"
          element={<UserTransactionList />}
        />

        <Route
          path="/user/creat-chank-file"
          element={<CreatChankfile />}
        />

        <Route
          path="/user/little-info"
          element={<LittelInfo />}
        />

        <Route
          path="/user/settlements"
          element={<Settlements />}
        />

        <Route
          path="/user/wob-list"
          element={<WobList />}
        />

        <Route
          path="/user/sell-funnel"
          element={<Qif />}
        />

        <Route
          path="/user/edit-number"
          element={<ChangeUserNumber />}
        />

        <Route
          path="/user/welcome-message"
          element={<WelcomeMessage />}
        />

        {/* =========================
            Admin Routes
        ========================= */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute
              element={<AdminDashboard />}
            />
          }
        />

        <Route
          path="/admin/publish"
          element={<AdminPublishList />}
        />

        <Route
          path="/admin/settlement-requests"
          element={<SettlementRequestsList />}
        />

        <Route
          path="/admin/changePassword"
          element={<AdminChangePassword />}
        />

        <Route
          path="/admin/create-plan"
          element={<CreatePlan />}
        />

        <Route
          path="/admin/plans"
          element={<MyPlans />}
        />

        <Route
          path="/admin/edit-plan"
          element={<EditPlan />}
        />

        <Route
          path="/admin/offer-codes"
          element={<OfferCodes />}
        />

        <Route
          path="/admin/user-plan-list"
          element={<UserPlansList />}
        />

        <Route
          path="/admin/plan-request"
          element={<PersonalPlanRequest />}
        />

        <Route
          path="/admin/transactions-list"
          element={<TransactionsList />}
        />

        <Route
          path="/admin/Setting"
          element={<Setting />}
        />

        <Route
          path="/admin/create-funnel-criteria"
          element={<CreateFunnelCriteria />}
        />

        <Route
          path="/admin/create-ready-funnel"
          element={<CreateReadyFunnel />}
        />

        <Route
          path="/admin/ready-funnels"
          element={<ReadyFunnels />}
        />


        {/* =========================
            Dashboard
        ========================= */}

        <Route
          path="/dashboard"
          element={<DashboardLayout />}
        />


        {/* =========================
            Bot
        ========================= */}

        <Route
          path="/bot/chat/:botType"
          element={<BotChat />}
        >
          <Route
            index
            element={<ChatConversion />}
          />
        </Route>


        <Route
          path="/chatbot/:username"
          element={<Bot />}
        />


        {/* =========================
            Client Register
        ========================= */}

        <Route
          path="/:username"
          element={<ClientRegister />}
        />

        <Route
          path="/otp-verification/:username"
          element={<ClientVerifyRegisterCode />}
        />

        <Route
          path="/password-verification/:username"
          element={<ClientEnterPassword />}
        />


        {/* =========================
            Client Dashboard
        ========================= */}

        <Route
          path="/bot/dashboard/:username"
          element={
            <ProtectedRoute
              element={<ClientDashboard />}
            />
          }
        />


        {/* =========================
            Client Chat
        ========================= */}

        <Route
          path="/bot/chatbox/:username"
          element={<ClientBotChatRoute />}
        >
          <Route
            index
            element={<ClientChatConversion />}
          />
        </Route>


        {/* =========================
            Client Wallet
        ========================= */}

        <Route
          path="/bot/wallet/:username"
          element={
            <ClientChatBotContainer
              headerTitle="کیف پول"
            />
          }
        />

        {/* =========================
            Client Profile
        ========================= */}

        <Route
          path="/bot/edit/:username"
          element={
            <ClientChatBotContainer
              headerTitle="حساب کاربری"
            />
          }
        />

        <Route
          path="/bot/client-change-password/:username"
          element={
            <ClientChatBotContainer
              headerTitle="حساب کاربری"
            />
          }
        />


        {/* =========================
            Client Payment
        ========================= */}

        <Route
          path="/bot/payment-gateway-method/:username"
          element={
            <ClientChatBotContainer
              headerTitle="کیف پول"
            />
          }
        />

        <Route
          path="/bot/client-payment-feedback/:username"
          element={
            <ClientChatBotContainer
              headerTitle="کیف پول"
            />
          }
        />
        <Route
          path="/bot/client-transaction-list/:username"
          element={
            <ClientChatBotContainer
              headerTitle="پرداختی ها"
            />
          }
        />


        {/* =========================
            Payment
        ========================= */}

        <Route
          path="/cart"
          element={<PlanCart />}
        />

        <Route
          path="/payment-method"
          element={<PaymentOptions />}
        />

        <Route
          path="/payment-gateway-method"
          element={<PaymentGatewaySelector />}
        />

        <Route
          path="/wallet"
          element={<UserWallet />}
        />

        <Route
          path="/payment-feedback"
          element={<PaymentFeedback />}
        />


        {/* =========================
            Other Pages
        ========================= */}

        <Route
          path="/test"
          element={<Test />}
        />

        <Route
          path="/"
          element={<Landing />}
        />

        {/* <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        /> */}

        {/* <Route
          path="/terms-and-conditions"
          element={<TermsAndConditions />}
        /> */}

        <Route
          path="/blog/:blogId"
          element={<Blogs />}
        />


        {/* =========================
            404
        ========================= */}

        <Route
          path="/notfound"
          element={<NotFoundPage />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/notfound"
              replace
            />
          }
        />

      </Routes>
    </>
  );
};


/* =========================
   App
========================= */

const App = () => {
  useModeSetting();

  return (
    <ThemeProvider>
      <LanguageProvider>
        <ToastProvider>
          <Router>
            <SidebarProvider>
              <AppRoutes />
            </SidebarProvider>
          </Router>
        </ToastProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;